export const showSnack = {
    data() {
        return {
            snack: false,
            snackColor: '',
            snackText: ''
        }
    },
    methods: {
        showSnack(msg, color) {
            this.snack = true;
            this.snackText = msg;
            this.snackColor = color;
        }
    }
}
